import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { DBService } from '../../../services/db.service';
import { Company } from '../../../model/company';
import { User } from '../../../model/user';
import { Employee } from '../../../model/employee';
import { AuthenticationService } from '../../../services/authentication.service';

declare var $: any;

@Component({
  selector: 'app-input-data',
  templateUrl: './input-data.component.html',
  styleUrls: ['./input-data.component.css'],
  providers: [DBService, AuthenticationService]
})
export class InputDataComponent implements OnInit {

  title: string;
  inputData: string;
  biddable: string;

  actionText: string;

  complement: string;

  placeHolder: string;

  isCurrency: boolean;

  companies: Company[];
  companyEmployees: Employee[];
  userCompanyUID: string;
  user: User;
  companyFilter: string;
  isAdminUser: boolean;

  list: any[];
  participants: string;
  position: string;
  observation: string;

  isAcceptLicitation: boolean;
  isWinOrList: boolean;

  result: any;

  constructor(
    private dbService: DBService,
    private authService: AuthenticationService,
    public dialogRef: MatDialogRef<InputDataComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

      this.user = new User();

      this.list = [];

      this.title = data.title;
      this.inputData = data.inputData;
      this.biddable = data.biddable;
      this.isCurrency = data.isCurrency === true;
      this.isAcceptLicitation = data.isAcceptLicitation;
      this.isWinOrList = data.isWinOrList;

      this.isAdminUser = this.authService.isAdmin();

      this.placeHolder = data.placeHolder;
      if (!this.placeHolder) {
        this.placeHolder = 'Nome';
      }

      if (!this.authService.isAdmin()) {
        this.userCompanyUID = this.authService.getUserCompany();
        this.user = this.authService.getUser();
        this.loadCompanies();
      }

      $('#overlay').show();
    }

    private loadCompanies() {
      this.dbService.listWithUIDs<Company>('companies')
        .then(companies => {
          if (this.userCompanyUID) {
            this.companies = companies.filter(c => c.uid === this.userCompanyUID);
          } else {
            this.companies = companies;
          }
        });        
      this.loadcompanyEmployees();
    }

    private loadcompanyEmployees() {
      this.dbService.listWithUIDs<Employee>('employees')
        .then(companyEmployees => {
          if (this.userCompanyUID) {
            this.companyEmployees = companyEmployees.filter(u => u.companyUID === this.userCompanyUID);
            this.companyEmployees = this.companyEmployees.filter(u => u.name != this.user.name);
          } else {
            this.companyEmployees = companyEmployees;
          }
        });
    }

  hideOverlay(): void {
    if (this.isAcceptLicitation) {
      this.result = { inputData: this.inputData, biddable: this.biddable, list: this.list };
    } else if (this.isWinOrList) {
      this.result = { inputData: this.inputData, biddable: this.biddable, participants: this.participants, position: this.position, observation: this.observation  };
    } else {
      this.result = this.inputData;
    }
    this.dialogRef.close(this.result);

    $('#overlay').hide();
  }

  closeOverlay () {
    this.dialogRef.close(this.result);
    $('#overlay').hide();
  }

  showBiddable () {
    console.log(this.biddable);
  }

  ngOnInit() {
  }

  addItem() {
    this.list.push({type: 'Item'});
  }

  addLote() {
    this.list.push({type: 'Lote'});
  }

  remove(index: number) {
    this.list.splice(index, 1);
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/partials/input-data/input-data.component.ts